/* eslint-env browser */
import { getCurrentBreakpoint } from './Responsive.helper.js';

let componentsList = [];
let hasListener = false;

function shouldBreakpointChange(component, currentBreakpoint) {
  if (currentBreakpoint !== component.state.currentBreakpoint) {
    component.setState({ currentBreakpoint });
  }
}

function listener() {
  const currentBreakpoint = getCurrentBreakpoint('', true);
  componentsList.map(component => shouldBreakpointChange(component, currentBreakpoint));
}

function subscribe(component) {
  componentsList.push(component);

  if (!hasListener) {
    window.addEventListener('resize', listener);
    hasListener = true;
  }
}

function unsubscribe(component) {
  componentsList = componentsList.filter(item => item !== component);

  if (!componentsList.length) {
    hasListener = false;
    window.removeEventListener('resize', listener);
  }
}

export { subscribe, unsubscribe };
